import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { defaultFilters } from '@user/store/lead/filters'
import { IOption } from '@user/components/Filters'
import { useSaveLeadFilters } from '@user/store/lead/hooks'

import { currencyString } from '@sales-center/common'
import { TotalAndDescription } from '../../../TotalAndDescription'

interface Props {
  count: number
  value: number
  assignees?: IOption[]
  salesTeams?: IOption[]
  canViewLeads: boolean
}

export const Leads: FC<Props> = (props) => {
  const { count, value, assignees, salesTeams, canViewLeads } = props
  const navigate = useNavigate()

  const saveLeadFilters = useSaveLeadFilters()

  const callToAction = useCallback(() => {
    saveLeadFilters({
      ...defaultFilters,
      filters: {
        ...defaultFilters.filters,
        nextActionDate: {
          ...defaultFilters.filters.nextActionDate,
          value: {
            matchType: 'lt',
            start: new Date(),
            end: null,
          },
        },
        salesTeamIds: {
          ...defaultFilters.filters.salesTeamIds,
          value: { mode: 'any', options: salesTeams || [] },
        },
        assignee: {
          ...defaultFilters.filters.assignee,
          value: { mode: 'any', options: assignees || [] },
        },
      },
    })
    navigate('/leads')
  }, [assignees, navigate, salesTeams, saveLeadFilters])

  return (
    <TotalAndDescription
      testIdPrefix="overdue-next-action-dates-widget-leads-section"
      callToActionFunction={callToAction}
      callToActionText="Review"
      callToActionAllowed={canViewLeads}
      description={
        <>
          {count == 1 ? 'This Lead has' : 'These Leads have'} a total value of{' '}
          <b>{`$${currencyString(value)}`}</b>.
        </>
      }
      headerText={count == 1 ? 'Lead' : 'Leads'}
      total={count}
    />
  )
}

Leads.displayName = 'Leads'
